import { HttpClient } from "@angular/common/http";
import { Inject, Injectable, InjectionToken } from "@angular/core";
import { LoginRequest, LoginResponse, RegisterRequest, Token, User } from "@estatex/types";
import { BehaviorSubject, Observable, tap } from "rxjs";
import { environment } from "@estatex/environments";
import { Router } from "@angular/router";
import { DOCUMENT } from "@angular/common";

// TODO: Move this to store

@Injectable({
    providedIn: "root",
})
export class UserService {
    private token: string;
    private user: User;

    loggedIn$: BehaviorSubject<boolean>;
    sessionStorage: Storage;

    constructor(private readonly httpClient: HttpClient, @Inject(DOCUMENT) private readonly document, private readonly router: Router) {
        this.sessionStorage = this.document.defaultView.sessionStorage;

        this.loggedIn$ = new BehaviorSubject<boolean>(false);
        if (this.sessionStorage?.getItem("token")) {
            this.token = this.sessionStorage.getItem("token");
            this.user = JSON.parse(this.sessionStorage.getItem("user"));
            this.loggedIn$.next(true);
            return;
        }
        this.loggedIn$.next(false);
    }

    /**
     * Logs in and sets the token for future use
     * @param login - LoginRequest
     * @returns
     */
    login(login: LoginRequest): Observable<LoginResponse> {
        return this.httpClient.post<LoginResponse>(`${environment.API_URL}/api/user/login`, login).pipe(
            tap((loginResponse) => {
                if (loginResponse === null) {
                    throw new Error("Login failed");
                }
                this.token = loginResponse.token;
                this.user = loginResponse.user;
                this.sessionStorage.setItem("token", this.token);
                this.sessionStorage.setItem("user", JSON.stringify(this.user));
                this.loggedIn$.next(true);
            })
        );
    }

    public set setToken(token: string) {
        this.token = token;
    }

    public get getToken(): string {
        return this.token;
    }

    public get getUser(): User {
        return this.user;
    }

    /**
     * Logs out and removes token and user from session
     */
    logout(): void {
        this.removeSessionDetails();
        this.loggedIn$.next(false);
        this.router.navigate(["/login"]);
    }

    /**
     * Removes token and user from session
     */
    removeSessionDetails(): void {
        if (this.sessionStorage?.getItem("token")) {
            this.sessionStorage.removeItem("token");
        }
        if (this.sessionStorage?.getItem("user")) {
            this.sessionStorage?.removeItem("user");
        }
        this.token = null;
    }

    register(registerRequest: RegisterRequest): Observable<LoginResponse> {
        return this.httpClient.post<LoginResponse>(`${environment.API_URL}/api/user/register`, registerRequest);
    }


    testGateway() {
        return this.httpClient.get("https://kw80c4g8kcs844o40kks80k8.instance1.theoutlookinn.in/test");
    }
}
